export default "__VITE_ASSET__8DyWSR4i__"